import styled from '@emotion/styled';
import { Icon } from 'antd';
import { Form as SemanticForm } from 'semantic-ui-react';

import { color, font, mediaQueries } from 'src/shared/styles/variables';

export const AuthorizationBoxWrapper = styled('div')({
    padding: '0px 40px',
    maxWidth: 460,
    borderRadius: 4,
    [mediaQueries.md]: {
        padding: 30,
    },
});

export const Header = styled('div')({
    width: 310,
    maxWidth: '100%',
    paddingbottom: 10,
});

export const Title = styled('h3')(
    {
        margin: 0,
        color: color.pickledBluewood,
    },
    font.heavy(font.size.large),
);

export const Subtitle = styled('h5')(
    {
        color: color.tundora,
        lineHeight: 1.8,
    },
    font.book(font.size.medium),
);

export const SmallInfo = styled('p')(
    {
        margin: '30px 0 0 0',
        color: color.scorpion,
    },
    font.medium(font.size.base),
);

export const QuestionWrapper = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    margin: '10px auto 0',
});

export const Question = styled('span')(
    {
        letterSpacing: '0.2px',
        color: color.rollingStone,
    },
    font.medium(font.size.base),
);

export const ChangeModeButton = styled('button')(
    {
        '&&': {
            padding: '0 0 2px 4px',
            margin: 0,
            width: 'auto',
            backgroundColor: 'transparent',
            boxShadow: 'none',
            border: 'none',
            color: color.royalBlue,
        },
    },
    font.heavy(font.size.base),
);

export const SubmitFormButton = styled('button')(
    {
        display: 'block',
        padding: '14px 0 10px',
        width: '100%',
        marginTop: 25,
        borderRadius: 5,
        textAlign: 'center',
        background: color.royalBlue,
        margin: '25px auto 0',
        borderColor: 'transparent',
        color: color.white,
        transition: '.2s ease-in-out background',
        '&:disabled': {
            cursor: 'not-allowed',
            opacity: 0.2,
        },
        '&:hover': {
            background: color.denim,
        },
    },
    font.medium(font.size.mediumExtended),
);

export const LoadingIcon = styled(Icon)({
    fontSize: 24,
    color: color.white,
});

export const Form = styled(SemanticForm)({
    marginTop: 33,
    marginBottom: 25,
});
